import { gql } from '@apollo/client'

import { CUSTOMER_FRAGMENT } from '.'

export const USER_FRAGMENT = gql`
  fragment User on User {
    email
    firstName
    fullName
    id
    isAnonymous
    isCustomer
    lastName
    phone
    userRealName
    customer {
      ...Customer
    }
  }
  ${CUSTOMER_FRAGMENT}
`
